import { useMemo } from "react";

import { getFaireDirectBrandFromTokenOrAlias } from "./__internal__/getFaireDirectBrandFromTokenOrAlias";
import { useFaireDirectBrandsForVisitor } from "./__internal__/useFaireDirectBrandsForVisitor";
import { BrandTokenOrBrandAlias } from "./faireDirectTypes";

export const useFaireDirectBrandTokenAndAlias = (
  params: BrandTokenOrBrandAlias
) => {
  const { faireDirectBrandsForVisitor, isPending } =
    useFaireDirectBrandsForVisitor();

  const faireDirectBrand = useMemo(() => {
    if (isPending) {
      return undefined;
    }
    return getFaireDirectBrandFromTokenOrAlias(
      params,
      faireDirectBrandsForVisitor
    );
  }, [isPending, faireDirectBrandsForVisitor]);

  return {
    brandToken: faireDirectBrand?.brand_token,
    brandAlias: faireDirectBrand?.brand_token_alias,
    isPending,
  };
};
